import React from 'react';
import { connect } from 'react-redux';

import * as API from '../core/api';
import * as Drift from '../utils/drift';
import Render from '../common/Render';
import { requestDataIfNeeded as getWorkspace } from './duck';
import i18n from '../core/i18n';
import * as Date from '../utils/date';
import lockedImg from '../img/locked.svg';
import { requestDataIfNeeded as getUser } from '../user/duck';

class CoreDataProvider extends React.Component {
  async componentDidMount() {
    const { isLoggedIn, token } = this.props;

    API.setAuthToken(token);
    this.props.getWorkspace({ full: isLoggedIn });

    if (isLoggedIn) {
      const user = await this.props.getUser();
      Drift.init(user);
    }
  }

  async componentDidUpdate(prevProps) {
    const { lang, teamName, isLoggedIn, token } = this.props;

    // Always update the auth token, if there is a change
    if (prevProps.token !== token) {
      API.setAuthToken(token);
    }

    // If user comes from nog logged-in state and logs in, do some initiations
    if (!prevProps.isLoggedIn && isLoggedIn) {
      const user = await this.props.getUser();
      Drift.init(user);
    }

    // Always update the workspace data, if user logs in or out.
    // In order to get all additional workspace fields,
    // which the logged in person receives.
    if (prevProps.isLoggedIn !== isLoggedIn) {
      this.props.getWorkspace({ full: isLoggedIn });
    }

    // As soon as language changes, re-init all related stuff
    if (prevProps.lang !== lang) {
      i18n.changeLanguage(lang);
      Date.init(lang);
    }

    if (teamName && prevProps.teamName !== teamName) {
      document.title = i18n.t('docTitle', { name: teamName });
    }
  }

  renderAfterLoading = () => {
    const { isInactive } = this.props;

    if (isInactive) {
      return (
        <div className="o-wrapper o-wrapper--small o-wrapper--vertical u-text-center">
          <h1>{i18n.t('admin.settingsScreen.subscription.lockedTitle')}</h1>
          <p className="u-margin-bottom-huge">
            {i18n.t('admin.settingsScreen.subscription.lockedTextLine1')}
            <br />
            {i18n.t('admin.settingsScreen.subscription.lockedTextLine2')}
          </p>
          <img src={lockedImg} alt="Locked Workspace" />
        </div>
      );
    }

    return this.props.children;
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapStateToProps = ({ workspace, user, auth }) => ({
  token: auth.data && auth.data.token,
  isLoggedIn: !!(auth.data && auth.data.token),
  // Do not load before all there are fetched
  isLoading:
    (workspace.isLoading || user.isLoading || auth.isLoading || !workspace.data)
    && workspace.error === null,
  error: workspace.error,
  // Sometimes user data is not yet received.
  // In the meanwhile, use the workspace lang.
  lang:
    (user.data && user.data.lang) || (workspace.data && workspace.data.lang),
  teamName: workspace.data && workspace.data.name,
  isInactive:
    workspace.data &&
    workspace.data.status &&
    workspace.data.status.status === 'INACTIVE',
});

const mapDispatchToProps = { getWorkspace, getUser };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoreDataProvider);



// WEBPACK FOOTER //
// ./src/workspace/CoreDataProvider.js